import { useEffect, useMemo, useState } from 'react';

type VersionInfo = {
    version: string | null;
    branch: string | null;
    commitHash: string | null;
};

const useAppVersion = (): VersionInfo => {
    const [versionInfo, setVersionInfo] = useState<VersionInfo>({ version: null, branch: null, commitHash: null });

    useEffect(() => {
        // Prefer Vite env variables if available
        const envVersion = import.meta.env?.VITE_APP_VERSION;
        const envBranch = import.meta.env?.VITE_GIT_BRANCH;
        const envCommit = import.meta.env?.VITE_GIT_COMMIT;

        if (envVersion || envBranch || envCommit) {
            setVersionInfo({
                version: envVersion ?? null,
                branch: envBranch ?? null,
                commitHash: envCommit ?? null,
            });
            return;
        }

        // Fallback: fetch from endpoints if env vars not present
        const fetchVersionInfo = async () => {
            try {
                const responses = await Promise.all([fetch('/VERSION'), fetch('/BRANCH'), fetch('/COMMITHASH')]);
                if (responses.some(response => !response.ok)) return;
                const [version, branch, commitHash] = await Promise.all(responses.map(response => response.text()));
                setVersionInfo({ version: version ?? null, branch: branch ?? null, commitHash: commitHash ?? null });
            } catch (_) {
                // ignore
            }
        };
        fetchVersionInfo();
    }, []);

    return versionInfo;
};

export default useAppVersion;
